/**
 * API utilities for Flux DC
 *
 * Uses API_BASE_URL from shared-ui + fetch(), same pattern as flux-ev-web.
 */

import { API_BASE_URL } from '@vortx/shared-ui';

const DC_API_PREFIX = '/api/flux_dc/v1';

/**
 * Make an authenticated fetch to the Flux DC API.
 * @param {string} endpoint - Path after /api/flux_dc/v1 (e.g., '/projects')
 * @param {object} options - fetch options (method, body, headers, etc.)
 * @returns {Promise<any>} parsed JSON response
 */
export async function fetchDC(endpoint, options = {}) {
  const url = `${API_BASE_URL}${DC_API_PREFIX}${endpoint}`;
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
  if (!response.ok) {
    const errorBody = await response.text().catch(() => '');
    throw new Error(`DC API error ${response.status}: ${errorBody}`);
  }
  return response.json();
}
